import {
  isBrowser,
  isMobile
} from "react-device-detect";
import React, { useState, useCallback, useRef } from 'react';
import styled from '@emotion/styled';

import IconPackage from 'xiv-fanfes-2021';

import * as breakpoint from '../../styles/breakpoints.module.scss';

const Ingedient = ({item}) => {
  const [ tooltipOpened, setTooltipOpened ] = useState(false);
  const [ tooltipOffset, setTooltipOffset ] = useState(0);
  const [ tooltipWidth, setTooltipWidth ] = useState(0);
  const annotationRef = useRef(null);
  const wrapperRef = useRef(null);
  const openTooltip = useCallback((e) => {
    e.preventDefault();
    setTooltipOpened(!tooltipOpened);
    setTooltipOffset(annotationRef.current.offsetLeft);
    setTooltipWidth(wrapperRef.current.clientWidth);
  },[setTooltipOpened,annotationRef,tooltipOpened])


  return (
  <IngedientWrapper className={`${tooltipOpened ? 'tooltipOpened' : ''}`} ref={wrapperRef}>
    <div className="name">
      {item.name}
      {item.annotation &&
        <AnnotationAnchor href="#" className="annotation" 
          ref={annotationRef}
          onClick={isMobile ? openTooltip : (e) => {e.preventDefault()}} 
          onMouseEnter={isBrowser ? openTooltip : null} 
          onMouseLeave={isBrowser ? openTooltip : null} >
          <IconPackage.Icon type={'Alert'} />
          <Tooltip offset={tooltipOffset} width={tooltipWidth}>
            {item.annotation}
          </Tooltip>
        </AnnotationAnchor>
      }
    </div>
    <div className="value">
      {item.value}
    </div>
  </IngedientWrapper>);
}
 
export default Ingedient;


const IngedientWrapper = styled.div`
  display: block;
  width: calc(50% - 16px);
  border-bottom: 1px dashed #CACACD;
  padding: 4px 0;
  position: relative;

  &:after {
    content: "";
    display: block;
    clear: both;
  }

  .name {
    float: left;
    margin-right: .5rem;
    color: #444448;
    letter-spacing: 0.03em;
    font-weight: 900;
    font-size: 14px;
    line-height: 24px;
    
  }

  .value {
    float: right;
    font-size: 14px;
    line-height: 24px;
    color: #444448;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;

    .name{
      font-size: 12px;
      line-height: 20px;
      .annotation, .annotation svg{
        width:12px;height:12px;
      }
    }
    .value{
      font-size: 12px;
      line-height: 20px;
    }
  }
`

const AnnotationAnchor = styled.a`
  display:inline-block;
  width:14px;
  height:14px;
  margin-left:4px;
  vertical-align:middle;
  position:relative;
  color:#838385;
  overflow:hidden;
  margin-top:-2px;
  
  svg{
    width:14px;
    height:14px;
    display:block;
  }

  .tooltipOpened &{
    overflow:visible;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    &, svg{
      width:12px;height:12px;
    }
  }

`

const Tooltip = styled.div`
  position:absolute;
  background: #FFFFFF;
  font-weight: 900;

  box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding:16px 24px;
  font-size: 12px;
  line-height: 18px;
  color: #444448;
  letter-spacing: 0.05em;
  bottom:100%;
  left:0;
  //transform:translateX(-50%);
  margin-bottom: 10px;
  opacity:0;
  transition:opacity .3s;
  margin-left: ${props => `-${props.offset}px`};
  width: ${props => `${props.width}px`};

  &:after{
    content:' ';
    display:block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0px 8px;
    border-color: #ffffff transparent transparent transparent;
    position:absolute;
    top:100%;
    left: ${props => `${props.offset }px`};
  }

  .tooltipOpened &{
    opacity:1;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:8px 16px;
    font-size: 10px;
    line-height: 14px;
  }

`
